module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "initial-center.47f7c0e5.svg";